module.exports = __webpack_public_path__ + "media/components/images/panels/8-a-75e49085651030e2439a88c0c0d41be9.jpeg";